// document.addEventListener('DOMContentLoaded', () => {
// 	AOS.init({
// 		startEvent: 'DOMContentLoaded',
// 		offset: 50,
// 		duration: 1000,
// 		once: true,
// 	});

// 	if (document.querySelector('.mobileNav__list .menu-item-has-children')) {
// 		let subMenus = document.querySelectorAll(
// 			'.mobileNav__list .menu-item-has-children'
// 		);
// 		subMenus.forEach(subMenu => {
// 			let link = subMenu.querySelector('a');
// 			let span = subMenu.querySelector('span')
// 			let ul = subMenu.querySelector('ul')
// 			link.addEventListener('click', (e) => {
// 				if(subMenu.querySelector('span')){
// 					e.preventDefault();
// 					ul.classList.toggle('sub-menu--open');
// 					span.classList.toggle('open')
// 				}
// 			});
// 		});
// 	}
// 	const hamburger = document.querySelector('.header .hamburger');
// 	const mobileNav = document.querySelector('.mobileNav');
// 	hamburger.addEventListener('click', () => {
// 		hamburger.classList.toggle('hamburger--opened');
// 		hamburger.setAttribute(
// 			'aria-expanded',
// 			hamburger.classList.contains('hamburger--opened')
// 		);
// 		mobileNav.classList.toggle('open');
// 	});
// 	const header = document.querySelector('.header');
// 	window.addEventListener('scroll', () => {
// 		document.body.scrollTop > 60 || document.documentElement.scrollTop > 60
// 			? header.classList.add('header--scrolled')
// 			: header.classList.remove('header--scrolled');
// 	});
// 	let vh = window.innerHeight * 0.01;
// 	document.documentElement.style.setProperty('--vh', `${vh}px`);

// 	window.addEventListener('resize', () => {
// 		vh = window.innerHeight * 0.01;
// 		document.documentElement.style.setProperty('--vh', `${vh}px`);
// 	});
// });




setTimeout(()=>{

        let invoice_filed_ask = document.querySelector("#billing_faktura, #billing_rachunek");
        let field_nip = document.querySelector("#billing_nip_field");
        let field_companyName = document.querySelector("#billing_company_field");
        if (invoice_filed_ask) {
          field_nip.style.display = 'none';
          field_companyName.style.display = 'none';
          if (invoice_filed_ask.checked) {
            field_nip.style.display="block";
            field_companyName.style.display="block";
          } else {
            field_nip.querySelector("input").setAttribute('value',"");
            field_companyName.querySelector("input").setAttribute('value',"");
          }
          invoice_filed_ask.addEventListener('click', () =>  {
            if ($(this).prop("checked")) {
              field_nip.style.display="block";
              field_companyName.style.display="block";
            } else {
              field_nip.style.display = 'none';
              field_nip.querySelector("input").setAttribute('value',"");
              field_companyName.style.display = 'none';
              field_companyName.querySelector("input").setAttribute('value',"");
            }
          });
        }
      

},500)

